import { useEffect, useRef, useState } from "react";
import "./DropdownInput.scss";

const DropdownInput = ({ options, name, value, disabled, dropdownType, dispatch, isRequired }) => {
  const [active, setActive] = useState(0);
  const [filtered, setFiltered] = useState([]);
  const [isShow, setIsShow] = useState(false); //pali/gasi izbornik
  const [input, setInput] = useState("");
  const [inputValueId, setInputValueId] = useState("");
  const dropdownRef = useRef();
  const dropdownInputRef = useRef();

  // close dropdown if mouse click occurred  outside
  const clickOutside = (e) => {
    if (isShow) {
      if (dropdownRef.current?.contains(e.target) || dropdownInputRef.current?.contains(e.target)) {
      } else {
        setIsShow(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", clickOutside);
    // clean up function before running new effect
    return () => {
      document.removeEventListener("mousedown", clickOutside);
    };
  }, [isShow]);

  const onChange = (e) => {
    const input = e.currentTarget.value;
    const newFilteredSuggestions = options.filter((option) => {
      if (dropdownType === "vrstaIzbora") {
        return option.typeName.toLowerCase().indexOf(input.toLowerCase()) > -1;
      } else {
        return option.name.toLowerCase().indexOf(input.toLowerCase()) > -1;
      }
    });
    setActive(0);
    setFiltered(newFilteredSuggestions);
    setIsShow(true);
    setInput(e.currentTarget.value);
  };

  useEffect(() => {
    let result = "";
    if (value !== 0) {
      result = options.find((option) => {
        return option.id === value;
      });

      if (result) {
        if (dropdownType === "vrstaIzbora") {
          setInput(result.typeName);
          setInputValueId(result.id);
        } else {
          setInput(result.name);
          setInputValueId(result.id);
        }
      } else {
        // console.log("result je null");
      }
    }
  }, [value, options, dropdownType]);

  useEffect(() => {
    let payloadData = {};
    if (dropdownType === "vrstaIzbora") {
      payloadData = {
        electionType: {
          id: inputValueId,
          typeName: input,
        },
      };
      dispatch({ type: "update", payload: payloadData });
    } else {
      payloadData = {
        location: {
          id: inputValueId,
          typeName: input,
        },
      };
      dispatch({ type: "update", payload: payloadData });
    }
  }, [inputValueId]);

  const onClickAutocomplete = () => {
    if (input === "") {
      setActive(0);
      setFiltered(options);
      setIsShow(true);
    }
  };

  const onDoubleClickAutocomplete = () => {
    setActive(0);
    setFiltered(options);
    setIsShow(true);
  };

  const onClick = (e) => {
    setActive(0);
    setFiltered([]);
    setIsShow(false);
    setInput(e.currentTarget.innerText);
    setInputValueId(e.currentTarget.value);
  };

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      // enter key
      setActive(0);
      setIsShow(false);
      if (dropdownType === "vrstaIzbora") {
        setInput(filtered[active].typeName);
        setInputValueId(filtered[active].id);
      } else {
        setInput(filtered[active].name);
        setInputValueId(filtered[active].id);
      }
    }
    // else if (e.keyCode === 38) {
    //   // up arrow
    //   return active === 0 ? null : setActive(active - 1);
    // } else if (e.keyCode === 40) {
    //   // down arrow
    //   return active - 1 === filtered.length ? null : setActive(active + 1);
    // }
  };

  const renderAutocomplete = () => {
    if (isShow) {
      if (filtered.length) {
        return (
          <ul
            className="autocomplete"
            ref={dropdownRef}
            //dropdown Vrsta izbora ima više mjesta, pa veći height. 202px da se podudara s crtom tablice :/
            style={{ maxHeight: dropdownType === "vrstaIzbora" ? "300px" : "202px" }}
          >
            {filtered.map((option, index) => {
              let className;
              if (index === active) {
                className = "active";
              }
              return (
                <li className={className} key={index} value={option.id} onClick={onClick}>
                  {dropdownType === "vrstaIzbora" ? option.typeName : option.name}
                </li>
              );
            })}
          </ul>
        );
      } else {
        return (
          <div className="no-autocomplete">
            <em style={{ color: "red" }}>Nije pronađeno</em>
          </div>
        );
      }
    }
    return <></>;
  };

  const placeholder = dropdownType === "vrstaIzbora" ? "Vrsta izbora" : "Lokacija";

  return (
    <>
      <div
        style={{
          width: "100%",
          height: "100px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        <input
          className={disabled ? "autocomplete-input input-field-disabled" : "autocomplete-input"}
          type="text"
          onChange={onChange}
          onKeyDown={onKeyDown}
          onClick={onClickAutocomplete}
          onDoubleClick={onDoubleClickAutocomplete}
          value={input}
          placeholder="_placeholder"
          ref={dropdownInputRef}
          name={name}
          disabled={disabled}
        />
        <label className="election-input-label-1 is-size-4" typeof="text" htmlFor="input1">
          {placeholder}
          {isRequired ? <span className="has-text-danger ml-1">*</span> : ""}
        </label>
        {renderAutocomplete()}
      </div>
    </>
  );
};

export default DropdownInput;
